const SECTION_IDS = {
	CAMPAIGNS_ID: 1,
	CONTENT_LIBRARY_ID: 2,
	EMAILS_ID: 4
};
const SECTION_NAMES = {
	'campaigns': 'Campaigns',
	'contentLibrary': 'Content Library',
	'emails': 'Emails',
};

const DEFAULT_CATEGORIES = {
	ALL_CATEGORIES: 'All Categories',
	FEATURED: 'Featured'
};

const DESCRIPTIONS = {
	CAMPAIGNS: 'Schedule automated campaigns to reach your audience through digital channels',
	CONTENT_LIBRARY: 'Access the full library of topical content that can be shared with clients to stay top of mind',
	EMAILS: 'Keep up with clients with email templates for financial milestones and life events'
};

const testSections = [{
	id: SECTION_IDS.CAMPAIGNS_ID,
	value: SECTION_IDS.CAMPAIGNS_ID,
	name: SECTION_NAMES.campaigns,
	description: DESCRIPTIONS.CAMPAIGNS,
	defaultCategory: DEFAULT_CATEGORIES.FEATURED
}, {
	id: SECTION_IDS.CONTENT_LIBRARY_ID,
	value: SECTION_IDS.CONTENT_LIBRARY_ID,
	name: SECTION_NAMES.contentLibrary,
	description: DESCRIPTIONS.CONTENT_LIBRARY,
	defaultCategory: DEFAULT_CATEGORIES.ALL_CATEGORIES
}, {
	id: SECTION_IDS.EMAILS_ID,
	value: SECTION_IDS.EMAILS_ID,
	name: SECTION_NAMES.emails,
	description: DESCRIPTIONS.EMAILS,
	defaultCategory: DEFAULT_CATEGORIES.ALL_CATEGORIES
}
];

const nonCampaignSections = [{
	id: SECTION_IDS.CONTENT_LIBRARY_ID,
	value: SECTION_IDS.CONTENT_LIBRARY_ID,
	name: SECTION_NAMES.contentLibrary,
	description: DESCRIPTIONS.CONTENT_LIBRARY,
	defaultCategory: DEFAULT_CATEGORIES.ALL_CATEGORIES
}, {
	id: SECTION_IDS.EMAILS_ID,
	value: SECTION_IDS.EMAILS_ID,
	name: SECTION_NAMES.emails,
	description: DESCRIPTIONS.EMAILS,
	defaultCategory: DEFAULT_CATEGORIES.ALL_CATEGORIES
}
];

export default {
	DEFAULT_CATEGORIES,
	DESCRIPTIONS,
	SECTION_IDS,
	SECTION_NAMES,
	testSections,
	nonCampaignSections
};